/**
 * Comment Like Remapper
 * Flutter: lib/data/models/comment_like.dart
 */
import type { CommentLikeDto } from '@/data/dtos/commentLike/commentLikeDto';
import type { JsonObject } from '@/data/types/json';
import type { CommentLikeStorage } from '@/domain/entities/secureStorage/secureStorageEntities';

export class CommentLikeRemapper {
  static toStorage(dto: CommentLikeDto): CommentLikeStorage {
    return {
      userId: dto.userId,
      commentId: dto.commentId,
      parentCommentId: dto.parentCommentId,
      liked: dto.liked,
      createdDate: dto.createdDate,
      updatedDate: dto.updatedDate,
    };
  }

  static fromJson(data: JsonObject): CommentLikeDto {
    return {
      userId: (data['userId'] as string | undefined) ?? '',
      commentId: (data['commentId'] as string | undefined) ?? '',
      parentCommentId: data['parentCommentId'] as string | undefined,
      liked: (data['liked'] as boolean | undefined) ?? false,
      createdDate: (data['createdDate'] as number | undefined) ?? 0,
      updatedDate: data['updatedDate'] as number | undefined,
    };
  }

  static fromJsonList(dataList: JsonObject[]): CommentLikeDto[] {
    return dataList.map(CommentLikeRemapper.fromJson);
  }

  static toJson(dto: CommentLikeDto): JsonObject {
    return {
      userId: dto.userId,
      commentId: dto.commentId,
      parentCommentId: dto.parentCommentId ?? null,
      liked: dto.liked,
      createdDate: dto.createdDate,
      updatedDate: dto.updatedDate ?? null,
    };
  }
}
